import { CourierTypeReportActionTypes } from "./actionTypes";

export const getCourierTypeReportList = (lazyState: any) => {
    return {
        type: CourierTypeReportActionTypes.GET_COURIER_TYPE_REPORT_LIST,
        lazyState,
    };
};

export const getCourierTypeReportListSuccess = (data: any) => {
    return {
        type: CourierTypeReportActionTypes.GET_COURIER_TYPE_REPORT_LIST_SUCCESS,
        payload: data,
    };
};

export const getCourierTypeReportListError = (error: any) => {
    return {
        type: CourierTypeReportActionTypes.GET_COURIER_TYPE_REPORT_LIST_FAIL,
        payload: error,
    };
};
